
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.266 15.946V4.23a2.86 2.86 0 00-2.859-2.859H9.26a2.86 2.86 0 00-2.66 1.83H2.169a1.43 1.43 0 00-1.43 1.43v4.217a1.43 1.43 0 001.43 1.43H6.4v6.19a2.86 2.86 0 002.859 2.86h7.148a2.86 2.86 0 002.86-2.86v-.522zM9.26 2.801h7.148a1.43 1.43 0 011.43 1.43v11H7.829V11.2l.83 1.03a.715.715 0 00.6.264c.06.007.12.007.179 0a.715.715 0 00.521-.58l.265-1.615h1.315a1.43 1.43 0 001.43-1.43V4.632a1.43 1.43 0 00-1.43-1.43H8.251a1.43 1.43 0 011.008-.4zM2.168 4.63h9.328v4.217H9.581a.715.715 0 00-.715.6l-.093.587-.75-.922a.522.522 0 00-.115-.1c-.036 0-.064-.05-.107-.072l-.143-.021a.508.508 0 00-.143 0H2.168V4.63zm14.24 13.267h-7.15A1.43 1.43 0 017.83 16.66h10.008a1.43 1.43 0 01-1.43 1.237z","fill":"#374151"}}),_c('path',{attrs:{"d":"M6.857 7.492a.715.715 0 100-1.43.715.715 0 000 1.43zM9.002 7.492a.715.715 0 100-1.43.715.715 0 000 1.43zM4.713 7.492a.715.715 0 100-1.43.715.715 0 000 1.43z","fill":"#374151"}})])
          )
        }
      }
    